import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import { trackVisit } from './utils/trackVisit';
import './App.css'

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    trackVisit();
  }, [location.pathname]);

  return (
    <>

      <main>
        <Header />
        <Outlet />
      </main>
    </>
  );
}
